import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Form, Button, Spinner, Card } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { RiSave2Line, RiArrowLeftLine } from "react-icons/ri";

import { placeBook } from "../apis";

function BookInsurranceForm({ email, name, insurranceName, token }) {
  const [telephone, setTelephone] = useState("");
  const [message, setMessage] = useState("");
  const [contactPreference, setContactPreference] = useState("email");
  const [loading, SetLoading] = useState(false);
  const { t } = useTranslation();

  //   Function to return to the insurrances page
  const history = useNavigate();
  const slug = useParams();
  const onBack = () => history("/insurrances");

  const onClick = async () => {
    SetLoading(true);

    // Validate Phone number from stackoverflow
    var phoneregex = /^\+?([0-9][0-9]{3})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
    if (!telephone.match(phoneregex)) {
      toast.error("Numero de telephone incorrect");
      SetLoading(false);
    } else {
      const data = {
        name,
        email,
        insurrance_name: insurranceName,
        telephone,
        message,
        contact_preference: contactPreference,
      };
      placeBook(data, token).then((res) => {
        setTimeout(onBack, 8000);
      });
    }
  };

  return (
    <Card className="booking-container">
      <h4 className="text-center">{t("book_page_form_title")}</h4>
      <Form className="booking-form">
        <Form.Group>
          <Form.Label>{t("book_page_form_input-label_name")}</Form.Label>
          <Form.Control label="text" value={name} disabled />
        </Form.Group>

        <Form.Group>
          <Form.Label>{t("book_page_form_input-label_email")}</Form.Label>
          <Form.Control label="text" value={email} disabled />
        </Form.Group>

        <Form.Group>
          <Form.Label>
            {t("book_page_form_input-label_insurrance-type")}
          </Form.Label>
          <Form.Control label="text" value={insurranceName} disabled />
        </Form.Group>

        <Form.Group className="u-mb-small">
          <Form.Label>{t("book_page_form_input-label_telephone")}</Form.Label>
          <Form.Control
            label="Numéro de téléphone:"
            type="phone"
            placeholder="+237675010203"
            value={telephone}
            onChange={(e) => setTelephone(e.target.value)}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>{t("book_page_form_contact_preference")}</Form.Label>
          <br />
          <Form.Check
            inline
            label="Email"
            name="Email"
            type="radio"
            checked={contactPreference === "email"}
            onChange={(e) => setContactPreference(e.target.value)}
            value="email"
            id={`email`}
          />
          <Form.Check
            inline
            label="Whatsapp"
            name="Whatsapp"
            checked={contactPreference === "whatsapp"}
            onChange={(e) => setContactPreference(e.target.value)}
            value="whatsapp"
            type="radio"
            id="whatsapp"
          />
        </Form.Group>

        <Form.Group className="u-mb-small">
          <Form.Label>{t("book_page_form_input-label_message")}</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Form.Group>
      </Form>
      <Button
        variant="blue"
        className=" u-mt-small btn-block"
        onClick={onClick}
        disabled={loading}
      >
        {loading ? (
          <Spinner
            variant="standard"
            as="span"
            size="sm"
            role="status"
            animation="border"
            aria-hidden="true"
          />
        ) : (
          [t("book_page_form_submit_button"), <RiSave2Line key={2} size="20" />]
        )}
      </Button>
      <Link to={`/insurrances/${slug.slug}`} className="return-back-btn">
        <RiArrowLeftLine size="20" />
        {t("book_page_form_return_back_button")}
      </Link>

      <ToastContainer containerId="an id" draggable={false} />
    </Card>
  );
}

export default BookInsurranceForm;
